import {PermissionType} from "./permissionType";

/**
 * Default permission type for organization members.
 *
 * @see https://coda.io/d/_dgH5XJ_OfpN/Organizations_suzFB#_lu23A
 */
export const PermissionTypeDefaultForOrganizationMembers = PermissionType.edit;

/**
 * Default permission type for enterprise members.
 */
export const PermissionTypeDefaultForEnterpriseMembers = PermissionType.edit;
